import { call, put, takeEvery, fork, all } from 'redux-saga/effects';
import axios from 'axios';


function * indexTimelineItemsAsync(data){
  let url='/api/all_timeline_items?user_workspace_id='+data.user_workspace_id+'&start_date='+data.start_date+'&end_date='+data.end_date+'&type='+data.d_type+'&sub_type='+data.sub_type+'&timezone='+getTimezone();
  try{
     const api = yield call([axios, axios.get], url)
     yield put({type:'REQUEST_INDEX_TIMELINE_ITEMS_SUCCESS', val:api.data, key:url})
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}
function* indexChartDataAsync(data) {
  try {
    const api = yield call([axios, axios.get], data.url)
    yield put({ type: 'REQUEST_INDEX_CHART_DATA_SUCCESS', val: api.data, key: data.url })
  } catch (error) { console.log(error, 'ERROR'); yield put({ type: 'REQUEST_ERROR', val: error.response }) }
}


function * getAnalyticsSettingsAsync(data){
  try{
     const api = yield call([axios, axios.get], '/api/analytics_settings')
     yield put({type:'REQUEST_GET_ANALYTICS_SETTINGS_SUCCESS', val:api.data})
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * createUpdateAnalyticsAsync(data){
  try{
     const api = yield call([axios, axios.post], '/api/create_update_analytics', data.val)
     yield put({type:'REQUEST_CREATE_UPDATE_ANALYTICS_CHART_SUCCESS', val:api.data})
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * deleteAnalyticsAsync(data){
  try{
     const api = yield call([axios, axios.delete], '/api/analytics/'+data.id)
     yield put({type:'REQUEST_DELETE_ANALYTICS_CHART_SUCCESS', val:api.data})
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * createScorecardAsync(data){
  try{
     const api = yield call([axios, axios.post], '/api/scorecards?timezone='+getTimezone(), data.payload)
     yield put({type:'REQUEST_CREATE_SCORECARD_SUCCESS', val:api.data});
     yield put({type:'REQUEST_FORM_COMPLETED', val:true});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function * updateScorecardAsync(data){
  try{
     const api = yield call([axios, axios.put], '/api/scorecards/'+data.id+'?timezone='+getTimezone(), data.payload)
     yield put({type:'REQUEST_UPDATE_SCORECARD_SUCCESS', val:api.data});
     yield put({type:'REQUEST_FORM_COMPLETED', val:true});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}


function * indexScorecardsAsync(data){
  try{
     const api = yield call([axios, axios.get], '/api/scorecards?timezone='+getTimezone())
     yield put({type:'REQUEST_INDEX_SCORECARDS_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');yield put({type:'REQUEST_ERROR', val:error.response})}
}

function* deleteScorecardAsync(data){
  try{
    const api = yield call([axios, axios.delete], '/api/scorecards/'+data.id)
    yield put({type:'REQUEST_DELETE_SCORECARD_SUCCESS', val:api.data});
  }catch(error){console.log(error, 'ERROR');
    yield put({type:'REQUEST_ERROR', val:error.response});
  }
}


function* Index_timeline_items(){yield takeEvery('REQUEST_INDEX_TIMELINE_ITEMS', indexTimelineItemsAsync);}
function* Index_chart_data(){yield takeEvery('REQUEST_INDEX_CHART_DATA', indexChartDataAsync);}
function* Get_analytics_settings(){yield takeEvery('REQUEST_GET_ANALYTICS_SETTINGS', getAnalyticsSettingsAsync);}
function* Create_update_analytics(){yield takeEvery('REQUEST_CREATE_UPDATE_ANALYTICS_CHART', createUpdateAnalyticsAsync);}
function* Delete_analytics(){yield takeEvery('REQUEST_DELETE_ANALYTICS_CHART', deleteAnalyticsAsync);}

function* Index_scorecards(){yield takeEvery('REQUEST_INDEX_SCORECARDS', indexScorecardsAsync);}
function* Create_scorecard(){yield takeEvery('REQUEST_CREATE_SCORECARD', createScorecardAsync);}
function* Update_scorecard(){yield takeEvery('REQUEST_UPDATE_SCORECARD', updateScorecardAsync);}
function* Delete_scorecard(){yield takeEvery('REQUEST_DELETE_SCORECARD', deleteScorecardAsync);}

export default function* Root_timeline_items(){
  yield all([
    fork(Index_chart_data),
    fork(Get_analytics_settings),
    fork(Create_update_analytics),
    fork(Delete_analytics),

    fork(Create_scorecard),
    fork(Update_scorecard),
    fork(Index_scorecards),
    fork(Delete_scorecard)
  ])}
